<template>
  <div
    class="web__msg"
    :style="{
      height: $store.state.inputHeight,
    }"
  >
    <!--		<el-autocomplete
			type="textarea"
			v-model="currentMsg"
			rows="6"
			:placeholder="placeholder"
			class="web__msg-input"
			:fetch-suggestions="querySearch"
			:trigger-on-focus="false"
			@select="handleSelect"
			placement="bottom"
			@input="inputNothing"
		>
			<template slot-scope="{ item }">
				<div class="name">{{ item.value }}</div>
			</template>
		</el-autocomplete>-->

    <i v-show="showBig" @click="showBigBox"
      ><img
        src="../../../static/icon/icon_fd.png"
        style="
          width: 25px;
          height: 25px;
          position: absolute;
          left: 80px;
          top: 10px;
        "
    /></i>
    <div class="showList" v-show="showKey && quickReplyItems.length > 0">
      <i @click="showSmall"
        ><img
          src="../../../static/icon/icon_sx.png"
          style="
            width: 1rem;
            height: 1rem;
            position: absolute;
            right: 10px;
            top: 5px;
          "
      /></i>
      <ul class="association">
        <li
          v-for="(item, index) in quickReplyItems"
          :key="index"
          @click="sureMsg(item.value)"
          v-html="item.value"
        >
          <!-- {{ item.value }} -->
        </li>
      </ul>
    </div>
    <div
      class="textarea_box"
      @contextmenu.prevent.stop="openMenu2"
      v-if="!feedback"
    >
      <div class="contextmenu2" v-show="menuVisible">
        <div
          class="contextmenu__item"
          v-clipboard:copy="copyText"
          v-clipboard:success="textCopy"
          v-clipboard:error="onError"
          @click="menuVisible = false"
        >
          复制
        </div>
        <div class="contextmenu__item" @click="clickPaste">粘贴</div>
      </div>
      <el-input
        type="textarea"
        id="textInput"
        placeholder="请输入聊天内容，支持关键词联想"
        v-model="currentMsg"
        @input="searchKey"
        style="width: 100%; height: auto"
        :rows="6"
        class="web__msg-input"
        show-word-limit
      ></el-input>
      <!-- :disabled="
          $store.state.toLastKeyName !== '对话中' &&
          $store.state.toLastKeyName !== '浏览中'
        " -->
    </div>
    <div class="feedback" v-if="feedback">
      <img
        src="../../../static/quick/close.png"
        @click="handleSendFeedBack"
        alt="加载失败"
      />
      <div class="feedback-text" @click="dialogVisible = true">
        <div>
          <img src="../.././../static/quick/feedback.png" alt="加载失败" />
        </div>
        <span>提交反馈</span>
      </div>
    </div>

    <!-- 对话反馈弹窗 -->
    <el-dialog
      title="备注"
      custom-class="el-dialog-crucial"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :lock-scroll="false"
      width="40%"
      @close="
        feedbackValue = '';
        handleSendFeedBack();
      "
    >
      <template slot="title">
        <span class="el-dialog__title">备注</span>
      </template>
      <el-input
        type="textarea"
        :autosize="{ minRows: 4 }"
        placeholder="请输入内容"
        v-model="feedbackValue"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          size="mini"
          style="background-color: #1577d2"
          @click="submitFeedback"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "JwChat_enterbox",
  props: {
    placeholder: {
      type: String,
      default: "请输入文字",
    },
    value: {
      default: "",
    },
    feedback: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    keyInfo: {
      type: Object,
      default: () => ({
        chatMessageId: [],
        remark: "",
        sid: "",
        depType: "",
      }),
    },
    config: {
      type: Object,
      default: () => ({
        name: "",
        ipdress: "",
        number: "4",
        tags: [],
        mark: "",
        itype: "0", //0-聊天界面引用  1-历史消息界面引用
        canOperate: Boolean, //界面元素是否可操作，false为不可，true为可以
      }),
      required: true,
    },
    selectedClient: {},
  },
  data() {
    return {
      currentMsg: "",
      selectMsg: "",
      quickReplyItems: [],
      popover: false,
      isDisable: this.textEnble,
      showKey: false,
      showBig: false,
      menuVisible: false,
      copyText: "",
      dialogVisible: false,
      feedbackValue: "",
      getFeedback: false,
      getList: [],
    };
  },
  computed: {
    keyName() {
      return this.$store.state.keyName;
    },
  },
  watch: {
    list() {
      this.getList = this.list;
    },
    value: {
      handler() {
        console.log("this.currentMsg ===" +this.value);
        this.currentMsg = this.value;
        if(this.$store.state.newQuickFlag){
          this.$store.state.newQuickFlag = false;
          const put = document.getElementById("textInput");
          console.log("this.currentMsg ===" +put);
          const len = this.value.length; 
          this.setSelectionRange(put, len, len);
        }
      },
      immediate: true,
    },
    feedback(newVal) {
      console.log("enterBox.vue  watch feedback:", this.feedback);
      this.getFeedback = newVal;
    },

    // currentMsg: {
    //   handler(newval) {
    //     const msg = newval.trim();
    //     this.$emit("input", msg);
    //     console.log("sssssssssssssssssssssssssssssssss");
    //   },
    //   immediate: true,
    // },
    selectedClient: {
      handler(newVal, oldVal) {
        console.log("entBox selectedClient newVal,oldVal:", newVal, oldVal);
        console.log("entBox selectedClient newVal,oldVal:", newVal.inputValue);
        if (
          newVal.value &&
          oldVal.inputValue &&
          newVal.inputValue === oldVal.inputValue
        ) {
          console.log("entBox selectedClient 成功");
          return;
        }
        if (newVal) {
          this.currentMsg = newVal.inputValue;
        } else {
          this.currentMsg = oldVal.inputValue ? oldVal.inputValue : null;
        }
        this.$emit("changeSendMessage", this.currentMsg);
      },
      deep: true,
      immediate: true,
    },
    // textEnble(newval, oldval) {
    // 	console.log('watch textEnble newval = ', newval)
    // 	console.log('watch textEnble oldval = ', oldval)
    // 	this.isDisable = newval
    // }
  },

  created() {
    console.log("enterbox textenble = ", this.textEnble);
    let self = this;
    this.currentMsg = this.$store.state.colleageAngle
      ? this.$store.state.college.nowSelectClient.inputValue
      : this.$store.state.selectedClient.inputValue;
    document.onkeydown = (e) => {
      let ev = document.all ? window.event : e;
      if (ev.keyCode === 13 && this.keyName === "对话中") {
        ev.returnValue = false;
        self.handleSend(ev);
      }
    };
  },
  methods: {
    async submitFeedback() {
      var diaLists = [];
      console.log(this.keyInfo);
      this.getList.forEach((item) => {
        if (item.isChecked === "1") {
          diaLists.push(item.id);
        }
      });
      if (this.feedbackValue === "") {
        this.$message.error("备注信息不能为空");
        return;
      }
      if (diaLists.length === 0) {
        this.$message.error("反馈信息不能为空");
        return;
      }

      var officeList = await this.handleGetOffice();
      console.log("officeList:", officeList);
      console.log("officeList:", this.keyInfo);
      if (officeList) {
        console.log(
          officeList.findIndex((item) => item.name === this.keyInfo.aduserId)
        );
        var officeIndex = officeList.findIndex(
          (item) => item.name === this.keyInfo.aduserId
        );
        console.log(officeIndex);
        console.log(this.keyInfo.aduserId);
        if (officeIndex !== -1) {
          var api = "/manager/wrongMessageDeal/add";
          const response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: {
              chatMessageId: diaLists,
              depType: Number(officeList[officeIndex].id),
              sid: this.keyInfo.sid,
              remark: this.feedbackValue,
            },
          });
          if (response.resultCode === "10000") {
            this.$message.success("反馈成功");
            this.dialogVisible = false;
            this.handleSendFeedBack();
          } else {
            this.$message.error(response.desc);
          }
        } else {
          this.$message.error("未找到与该账号相对应的科室");
        }
      } else {
        this.$message.error(officeList);
      }
    },
    // 得到科室列表
    async handleGetOffice() {
      var api = "/manager/departmentType/getDepTypeList";
      var response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: "",
      });
      if (response.resultCode === "10000") {
        return response.data;
      } else {
        return response.desc;
      }
    },
    // 针对单科室  获取科室

    setSelectionRange(input, selectionStart, selectionEnd) {
      if (input.setSelectionRange) {
        input.focus()
        input.setSelectionRange(selectionStart, selectionEnd)
      } else if (input.createTextRange) {
        const range = input.createTextRange()
        range.collapse(true)
        range.moveEnd('character', selectionEnd)
        range.moveStart('character', selectionStart)
        range.select()
      }
    },

    handleSendFeedBack() {
      console.log("getFeedbackState2");
      this.getFeedback = false;
      this.$emit("getFeedbackState2", this.getFeedback);
    },
    searchKey() {
      if (
        this.currentMsg.trim().length > 1 &&
        this.currentMsg.trim().length <= 10
      ) {
        this.search(this.currentMsg);
      } else {
        this.quickReplyItems = [];
        this.showBig = false;
      }
      this.$emit("changeSendMessage", this.currentMsg);
      if (this.$store.state.colleageAngle) {
        this.$store.state.college.nowSelectClient.inputValue = this.currentMsg;
      } else {
        this.$store.state.selectedClient.inputValue = this.currentMsg;
      }
      console.log(
        "enterBox this.$store.state.selectedClient:",
        this.$store.state.selectedClient.inputValue
      );
    },
    showSmall() {
      this.showBig = false;
      this.showKey = false;
    },
    showBigBox() {
      this.showKey = true;
      this.showBig = false;
    },
    sureMsg(val) {
      console.log("选中联想列表，即将发送的文本：", val);
      this.currentMsg = val
        .trim()
        .replace(/<\/?.+?\/?>/g, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">");
      console.log("选中联想列表，即将发送的文本：", this.currentMsg);
      document.getElementById("textInput").focus();
      this.$emit("changeSendMessage", this.currentMsg);
      this.showKey = false;
      this.showBig = false;
    },
    //用户主动发送
    handleSend(e) {
      console.log("enterBox handleSend e = ", e);
      const shiftKey = e.shiftKey;
      if (shiftKey) return;

      if (e.keyCode == 13) {
        this.$emit("submit", this.currentMsg);
        this.$nextTick(() => {
          this.currentMsg = "";
          this.quickReplyItems = [];
          this.showKey = false;
          this.showBig = false;
        });
      }
      if (this.$store.state.colleageAngle) {
        this.$store.state.college.nowSelectClient.inputValue = "";
      } else {
        this.$store.state.selectedClient.inputValue = "";
      }
    },
    async search(queryString) {
      if (queryString.trim() == "") {
        this.showBig = false;
        this.quickReplyItems = [];
        return;
      }
      var api = "/manager/QuickReplyQuery/selectByIntelligentContent";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          content: queryString,
        },
      });
    
      // console.log('search response = ', response)
      if (response.resultCode == 40003) {
        return;
      }
      this.quickReplyItems = response.data;
      if (this.quickReplyItems == null) {
        return;
      }
      this.showKey = true;
      this.showBig = false;
      var reg = this.currentMsg;
      for (var i = 0; i < this.quickReplyItems.length; i++) {
        console.log("reg:---------", reg);
        this.quickReplyItems[i].value = this.quickReplyItems[
          i
        ].content.replaceAll(reg, `<span style='color:#1577D2'>${reg}</span>`);
      }
      console.log(this.quickReplyItems);
    },
    querySearch(queryString, cb) {
      if (queryString.trim().length > 0 && queryString.trim().length <= 10) {
        this.search(queryString);
        // var api = '/manager/QuickReplyQuery/selectByContent';
        // const response = await this.util.postRequest({
        // 	url: api,
        // 	method: 'POST',
        // 	data: {
        // 		attributionType: 3,
        // 		content: queryString
        // 	}
        // });
        // console.log(response.data.listVos)
      } else {
        this.quickReplyItems = [];
      }
      this.$nextTick(() => {
        setTimeout(() => {
          console.log("querysearch quickReplyItems = ", this.quickReplyItems);
          if (this.quickReplyItems == null) {
            return;
          }
          // var results = queryString ? this.quickReplyItems.filter(this.createFilter(queryString)) : this.quickReplyItems;
          var results =
            this.quickReplyItems.length > 0
              ? this.quickReplyItems.length > 7
                ? this.quickReplyItems.slice(0, 7)
                : this.quickReplyItems
              : [];
          cb(results);
        }, 50);
      });
    },
    // createFilter(queryString){
    // 	return (quickReply) =>{
    // 		return (quickReply.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
    // 	}
    // },
    handleSelect(item) {
      this.currentMsg = item.value;
      this.useCountRequest(item);
    },

    inputNothing(val) {
      // console.log("输入值发生改变",val)
      console.log(val);
      if (val === "") {
        this.showBig = false;
        this.quickReplyItems = [];
      } else {
        this.search(val);
      }
    },

    async useCountRequest(obj) {
      console.log("enterBox useCountRequest obj = ", obj);
      var api = "/manager/quickReply/updateMessageReply";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: obj.id,
          attributionType: obj.attributionType,
          content: obj.content,
          dataType: obj.dataType,
        },
      });
      console.log("enterBox useCountRequest response = ", response);
      if (response.resultCode !== "10000") {
        this.$message.error(response.desc);
      }
    },

    // 右键菜单
    openMenu2(e) {
      if (this.config.canOperate) {
        this.menuVisible = this.menuVisible ? false : true;
        console.log("e", e);
        let text = window.getSelection().toString();
        if (text != "") {
          this.copyText = text;
        }
        var menu = document.querySelector(".contextmenu2");
        this.styleMenu(menu, e);
      } else {
        console.log("已禁用");
      }
    },

    styleMenu(menu, event) {
      // if(event.clientX>=1330){
      // 	menu.style.left = event.clientX + 'px'
      // }else{

      // }
      menu.style.left = event.offsetX + "px";
      menu.style.top = event.offsetY + "px";
    },

    onError(e) {
      console.log(e);
    },

    clickPaste() {
      console.log("navigator.clipboard", navigator.clipboard);
      console.log("this.$store.state.copyText", this.$store.state.copyText);
      this.currentMsg = this.$store.state.copyText;
      this.$emit("changeSendMessage", this.currentMsg);
      this.menuVisible = false;
    },

    textCopy(e) {
      console.log("复制", e.text);
      this.$store.state.copyText = e.text;
      // console.log("全文复制")
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-dialog-crucial {
  .el-dialog__body {
    padding: 2px 20px 10px;
  }
}

.web__msg {
  padding: 0 0.625rem;
  height: 130px;
  // flex: 1;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #f7fbf7;
  // background-color:#FEA47F;
}

.feedback {
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  & > img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 5px;
    cursor: pointer;
  }
  .feedback-text {
    text-align: center;
    cursor: pointer;
    div {
      display: flex;
      border: 2px solid #666666;
      margin: auto;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      align-items: center;
      justify-content: center;
      img {
        width: 20px;
        height: 20px;
      }
    }
    span {
      @include change_tip_size($tip_size_normal);
      font-family: Microsoft YaHei;
      color: #333333;
    }
  }
}
/* .web__msg .web__msg {
  height: 140px;
  background-color: #fff;
} */

.web__msg-input {
  display: block;
  width: 100%;
  height: 100% !important;
  overflow: hidden;
  // box-sizing: border-box;
  resize: none;
  outline: 0;
  // background-color: #9AECDB;
  border: none;
  word-break: break-all;
  font-size: 14px;
  line-height: 17px;
  -webkit-appearance: none;
  padding-top: 0.2rem;
}

.web__msg-input :deep() .el-textarea__inner {
  border: none;
  resize: none;
  height: 100%;
}

.showList {
  width: 500px;
  overflow: hidden;
  position: absolute;
  bottom: 100%;
  background: #fff;
  padding: 20px 20px 10px 20px;
  box-sizing: border-box;
  border: 1px #ddd solid;
}
.textarea_box {
  height: 100%;
}

.showList li {
  list-style: none;
  font-size: 12px;
  // height: 25px;
  line-height: 18px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  color: #333333;
  border-bottom: 1px dashed #ddd;
  padding: 6px 0;
}

.showList ul::-webkit-scrollbar {
  z-index: 11;
  width: 6px;
}

.showList ul::-webkit-scrollbar-track,
.showList ul::-webkit-scrollbar-corner {
  background: #fff;
}

.showList ul::-webkit-scrollbar-thumb {
  border-radius: 5px;
  width: 6px;
  background: #b4bccc;
}

.showList ul::-webkit-scrollbar-track-piece {
  background: #fff;
  width: 6px;
}

.contextmenu__item {
  display: block;
  line-height: 34px;
  text-align: center;
}
.contextmenu__item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.contextmenu2 {
  position: absolute;
  background-color: #fff;
  width: 100px;
  /*height: 106px;*/
  font-size: 12px;
  color: #444040;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  white-space: nowrap;
  z-index: 1000;
}
.association::-webkit-scrollbar {
  display: none;
}
.association {
  max-height: 130px;
  overflow-y: auto;
}
</style>
